import { Component } from 'preact';

import { MobileInput } from '@szn/suggestlist';

import Icon from '../../icon/Icon';

export default class MobileSearch extends Component {
	constructor() {
		super();

		this.state = {
			isModalVisible: false
		};

		this.onChangeModalVisibility = this.onChangeModalVisibility.bind(this);
	}

	render() {
		const { isModalVisible } = this.state;

		return (
			<MobileInput
				inputName={this.props.searchQueryParameter}
				inputClassName='ribbon-mobile-search__input'
				dataDot='lista_hledani_fulltext'
				isModalVisible={isModalVisible}
				onChangeModalVisibility={this.onChangeModalVisibility}
				inputPlaceholder='Hledat...'
				backIcon={<Icon icon='back' />}
				searchIcon={<Icon icon='search' />}
				clearIcon={<Icon icon='cross' />}
				onChange={this.props.onChange}
				onSubmit={this.props.onSubmit}
				searchPhrase={this.props.searchPhrase}
				suggestListItems={this.props.suggestListItems}
				onRemoveFromHistory={this.props.onRemoveFromHistory}
			/>
		);
	}

	onChangeModalVisibility(value) {
		this.props.onMobileModalToggle && this.props.onMobileModalToggle(value);

		this.setState({
			isModalVisible: value
		});
	}
}
